"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSuggestions = exports.getNonSuggestions = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _searchSuggestion = _interopRequireDefault(require("./search-suggestion"));

var _searchSuggestionFooter = _interopRequireDefault(require("./search-suggestion-footer"));

var _searchSuggestionHeader = _interopRequireDefault(require("./search-suggestion-header"));

var _isElementOf = _interopRequireDefault(require("./../_utils/is-element-of"));

var getSuggestions = function getSuggestions(children) {
  return _react["default"].Children.toArray(children).filter((0, _isElementOf["default"])(_searchSuggestion["default"])).map(function (child, index) {
    var _child$props = child.props,
        children = _child$props.children,
        onClick = _child$props.onClick,
        disabled = _child$props.disabled;

    var _ref = typeof children === "function" ? [children({}).props.suggestion, children] : [children, null],
        _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
        label = _ref2[0],
        render = _ref2[1];

    return {
      value: index,
      disabled: disabled,
      render: render,
      label: label,
      onClick: onClick
    };
  });
};

exports.getSuggestions = getSuggestions;

var getFooter = function getFooter(children) {
  return children.filter((0, _isElementOf["default"])(_searchSuggestionFooter["default"]))[0];
};

var getHeader = function getHeader(children) {
  var header = children.filter((0, _isElementOf["default"])(_searchSuggestionHeader["default"]))[0];
  return header ? header.props.children : "Search suggestions";
};

var getMessage = function getMessage(children) {
  return children.filter(function (child) {
    return !(0, _isElementOf["default"])(_searchSuggestion["default"])(child) && !(0, _isElementOf["default"])(_searchSuggestionFooter["default"])(child) && !(0, _isElementOf["default"])(_searchSuggestionHeader["default"])(child);
  });
};

var getNonSuggestions = function getNonSuggestions(children) {
  var childrenArray = _react["default"].Children.toArray(children);

  var footer = getFooter(childrenArray);
  var header = getHeader(childrenArray);
  var message = getMessage(childrenArray);
  return {
    footer: footer,
    header: header,
    message: message
  };
};

exports.getNonSuggestions = getNonSuggestions;